"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _shallowequal = _interopRequireDefault(require("shallowequal"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _Radio = _interopRequireDefault(require("./Radio"));
var _index = _interopRequireDefault(require("../Tooltip/index.js"));
var _StyledRadio = require("./StyledRadio");
var _ykbStyledComponents = require("../ykb-styled-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function getCheckedValue(children) {
  var value = null;
  var matched = false;
  React.Children.forEach(children, function (radio) {
    if (radio && radio.props && radio.props.checked) {
      value = radio.props.value;
      matched = true;
    }
  });
  return matched ? {
    value: value
  } : undefined;
}
var RadioGroup = /*#__PURE__*/function (_React$Component) {
  function RadioGroup(props) {
    var _this;
    (0, _classCallCheck2.default)(this, RadioGroup);
    _this = _callSuper(this, RadioGroup, [props]);
    (0, _defineProperty2.default)(_this, "onRadioChange", function (ev) {
      var lastValue = _this.state.value;
      var value = ev.target.value;
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }
      var onChange = _this.props.onChange;
      if (onChange && value !== lastValue) {
        onChange(value);
      }
    });
    var _value;
    if ('value' in props) {
      _value = props.value;
    } else if ('defaultValue' in props) {
      _value = props.defaultValue;
    } else {
      var checkedValue = getCheckedValue(props.children);
      _value = checkedValue && checkedValue.value;
    }
    _this.state = {
      value: _value
    };
    return _this;
  }
  (0, _inherits2.default)(RadioGroup, _React$Component);
  return (0, _createClass2.default)(RadioGroup, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        radioGroup: {
          onChange: this.onRadioChange,
          value: this.state.value,
          disabled: this.props.disabled,
          name: this.props.name,
          vertical: this.props.vertical
        }
      };
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if ('value' in nextProps) {
        this.setState({
          value: nextProps.value
        });
      } else {
        var checkedValue = getCheckedValue(nextProps.children);
        if (checkedValue) {
          this.setState({
            value: checkedValue.value
          });
        }
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowequal.default)(this.props, nextProps) || !(0, _shallowequal.default)(this.state, nextState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var props = this.props;
      var items = props.items;
      var children = props.children;
      if (items && items.length > 0) {
        children = items.map(function (option, index) {
          if (typeof option === 'string') {
            if (option.tooltipText) {
              return /*#__PURE__*/React.createElement(_index.default, {
                overlay: option.tooltipText,
                placement: option.tooltipPlacement ? option.tooltipPlacement : 'top'
              }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_Radio.default, {
                key: index,
                disabled: _this2.props.disabled,
                value: option,
                onChange: _this2.onRadioChange,
                checked: _this2.state.value === option
              }, option)));
            } else {
              return /*#__PURE__*/React.createElement(_Radio.default, {
                key: index,
                disabled: _this2.props.disabled,
                value: option,
                onChange: _this2.onRadioChange,
                checked: _this2.state.value === option
              }, option);
            }
          } else {
            if (option.tooltipText) {
              return /*#__PURE__*/React.createElement(_index.default, {
                overlay: option.tooltipText,
                placement: option.tooltipPlacement ? option.tooltipPlacement : 'top'
              }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_Radio.default, {
                id: option.id,
                key: index,
                disabled: option.disabled || _this2.props.disabled,
                value: option.value,
                onChange: _this2.onRadioChange,
                checked: _this2.state.value === option.value
              }, option.textLabel)));
            } else {
              return /*#__PURE__*/React.createElement(_Radio.default, {
                id: option.id,
                key: index,
                disabled: option.disabled || _this2.props.disabled,
                value: option.value,
                onChange: _this2.onRadioChange,
                checked: _this2.state.value === option.value
              }, option.textLabel);
            }
          }
        });
      }
      return /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/React.createElement(_StyledRadio.StyledRadioGroup, {
          theme: theme,
          className: props.className,
          style: props.style,
          onMouseEnter: props.onMouseEnter,
          onMouseLeave: props.onMouseLeave,
          id: props.id
        }, children);
      });
    }
  }]);
}(React.Component);
(0, _defineProperty2.default)(RadioGroup, "defaultProps", {
  disabled: false,
  items: [],
  vertical: false
});
(0, _defineProperty2.default)(RadioGroup, "childContextTypes", {
  radioGroup: _propTypes.default.any
});
RadioGroup.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  disabled: _propTypes.default.bool,
  items: _propTypes.default.array,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  /**
   * Whether or not should this component render child Radio components vertically
   */
  vertical: _propTypes.default.bool
};
RadioGroup.displayName = 'RadioGroup';
var _default = exports.default = (0, _inputHOC.default)(RadioGroup);